export default "__VITE_ASSET__49ea16d5__"